'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const wrapper = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-VariantDropdown-web-styleswrapper", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvcGxhdGZvcm0vUHJvZHVjdENhcmQvVmFyaWFudERyb3Bkb3duL1ZhcmlhbnREcm9wZG93bi53ZWIuc3R5bGVzLnRzIiwic291cmNlcyI6WyIvVXNlcnMvaWFuY2xhcmtlL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9WYXJpYW50RHJvcGRvd24vVmFyaWFudERyb3Bkb3duLndlYi5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmltcG9ydCB7IHpJbmRleCB9IGZyb20gXCIjY29uc3RhbnRzXCI7XG5cbmV4cG9ydCBjb25zdCB3cmFwcGVyID0gY3NzKHtcbiAgcGFkZGluZzogXCI4cHggMFwiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB6SW5kZXg6IHpJbmRleC5jYXJkQWN0aW9uLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXVCIn0= */");

exports.wrapper = wrapper;
//# sourceMappingURL=VariantDropdown.web.styles.cjs.map
